import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, redirect, useLocation } from '@tanstack/react-router'
import { Alert, Button, Skeleton } from 'antd'
import { RentalCreateForm, rentalListSearchSchema } from '@/features/order/index.ts'
import { useTRPC } from '@/trpc/react.ts'

export const Route = createFileRoute('/_authenticated/orders/rentals/edit/$rentalId')({
  beforeLoad: ({ params }) => {
    if (!Number.isSafeInteger(Number(params.rentalId)) || Number(params.rentalId) < 1) {
      throw redirect({ to: '/orders/rentals', search: { current: 1, pageSize: 20 } })
    }
  },
  component: EditRentalPage
})
function EditRentalPage() {
  const [revision, setRevision] = useState(0)
  const trpc = useTRPC()
  const savedReturnSearch = useLocation({ select: (location) => location.state.rentalListReturnSearch })
  const search = rentalListSearchSchema.parse(savedReturnSearch ?? {})
  const { currentSession } = Route.useRouteContext()
  const query = useQuery(trpc.order.rental.detail.queryOptions({ rentalOrderId: Number(Route.useParams().rentalId) }))
  if (query.isPending) {
    return <Skeleton active />
  }
  if (query.isError) {
    return (
      <Alert
        type="error"
        title={query.error.message}
        action={<Button onClick={() => void query.refetch()}>重试</Button>}
      />
    )
  }
  if (
    query.data.status === 'archived' ||
    (query.data.status !== 'pending' &&
      !currentSession.isSuperAdmin &&
      !currentSession.permissions.some(
        (permission) => permission.startsWith('order.rental.') && !permission.endsWith('.read')
      ))
  ) {
    return <Alert type="warning" title="当前订单已锁定，编辑需要订单管理权限；已归档订单只能补充备注与附件。" />
  }
  return (
    <RentalCreateForm
      key={`${query.data.id}:${revision}`}
      onRestore={() => setRevision((value) => value + 1)}
      existingOrder={query.data}
      returnSearch={search}
      canManageOrder={
        currentSession.isSuperAdmin ||
        currentSession.permissions.some(
          (permission) => permission.startsWith('order.rental.') && !permission.endsWith('.read')
        )
      }
    />
  )
}
